var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-block d-md-inline"},[_c('a',{staticClass:"btn btn-xs btn-link btn-icon bigger-130 text-success",attrs:{"title":"Editar"},on:{"click":_vm.mtd_emitActionEdit}},[_c('feather',{attrs:{"type":"edit"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }